/**
 * Worklist toolbar trigger for the global OncoEMR task notification center.
 *
 * Uses Oasis {@link NotificationIcon} with a count badge when the inbox poller
 * reports unread tasks (`is_updated`). Clicking opens the notification drawer
 * via {@link useTasksNotification} `openDrawer`.
 *
 * @module worklistTasksNotificationTrigger
 */
import { NotificationIcon } from "@risalabs_frontend_org/oasis-ui-kit";
import { useTasksNotification } from "../../../context/tasksNotification/tasksNotificationContext";
import { NotificationBellIcon } from "../../../svg/notificationBellIcon";

/**
 * Bell button on the All PA Orders header that opens the task notification drawer.
 *
 * @returns Oasis notification icon with an unread count badge when applicable.
 */
const WorklistTasksNotificationTrigger = () => {
  const { unreadCount, openDrawer } = useTasksNotification();
  const hasUnread = unreadCount > 0;

  return (
    <div
      className="worklist-tasks-notification-trigger shrink-0 border-l-2 border-primaryGray-7 pl-2"
      onClick={(event) => event.stopPropagation()}
    >
      <NotificationIcon
        icon={<NotificationBellIcon />}
        count={unreadCount}
        showIndicator={hasUnread}
        indicatorType="count"
        size="small"
        onClick={openDrawer}
        indicatorSize={8}
        iconSize={22}
        ariaLabel={
          hasUnread
            ? `Open task notifications, ${unreadCount} unread`
            : "Open task notifications"
        }
      />
    </div>
  );
};

export default WorklistTasksNotificationTrigger;
